import { getPriceInfo } from "./PriceInfoAction";

const dispatchGetPriceInfo = (dispatch: Function) => (subTypeId: any) => {
    dispatch(getPriceInfo(subTypeId));
};

const PriceInfoDispatch = {
    dispatchGetPriceInfo
};

export default PriceInfoDispatch